import { CSSProperties, ReactElement } from 'react'

import classNames from 'classnames'
import noop from 'lodash/noop'
import { darken, saturate, transparentize } from 'polished'

import { IconButton } from 'components/Buttons'
import { Icon } from 'components/core'
import { ResourceLink } from 'components/Links/ResourceLink'
import { LabelPageTabId } from 'routing/pageTabIds'
import { labelUrl } from 'routing/urls'
import { Label } from 'types'

import * as styles from './styles.scss'

interface LabelElementProps {
    isClosable?: boolean
    label: Label
    onClose?: () => void
    linkToTab?: LabelPageTabId
    className?: string
    style?: CSSProperties
    disabled?: boolean
}

export default function LabelElement({
    className,
    isClosable = false,
    label,
    onClose = noop,
    linkToTab,
    style,
    disabled: disableLink = false,
}: LabelElementProps): ReactElement {
    const color = saturate(0.22, darken(0.17, label.color))
    const backgroundColor = transparentize(0.87, label.color)
    const tag = (
        <div
            className={styles['label-link']}
            style={{
                color,
            }}
        >
            {label.name}
        </div>
    )

    return (
        <div
            className={classNames(className, styles['label-tag'])}
            style={{
                ...style,
                backgroundColor,
            }}
        >
            {!disableLink ? (
                <ResourceLink
                    to={labelUrl(label.id, linkToTab)}
                    style={{ textDecoration: 'none' }}
                >
                    {tag}
                </ResourceLink>
            ) : (
                tag
            )}
            {isClosable && (
                <IconButton
                    className={styles['close-btn']}
                    size="small"
                    icon={<Icon name="PLUS" rotate={45} size={10} />}
                    tooltipTitle="Remove label"
                    onClick={onClose}
                    style={{
                        color,
                    }}
                />
            )}
        </div>
    )
}
